
import { newModalFromString } from 'components/modal';
/**
 * Checks if the email value entered is correct format
 * @param {string} email - email string to check if valid
 * @returns {boolean} Whether email is valid
 */
function validateEmail(email) {
    var regex = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
    return regex.test(email);
};

function updateAvailabilityMessage (isComingSoon){
    if (isComingSoon){
        $('.availability-msg')
            .empty()
            .html($('.product-availability').data('notifymelabel'))
            .removeClass('uppercase')
            .removeClass('text-brand-red')
            .removeClass('text-brand-green')
            .removeClass('text-salmon')
            .addClass('text-medium-gray')
            .removeClass('hidden');

        $('.availability-msg-for-small')
            .empty()
            .html($('.product-availability').data('notifymelabel'))
            .removeClass('uppercase')
            .removeClass('text-brand-red')
            .removeClass('text-brand-green')
            .removeClass('text-salmon')
            .addClass('text-medium-gray')
            .removeClass('hidden');
        $('.coming-soon-error').removeClass('hidden');
        $('.out-of-stock-error').addClass('hidden');
    } else {
        $('.availability-msg')
            .empty()
            .html($('.product-availability').data('notifymelabel'))
            .removeClass('uppercase')
            .removeClass('text-salmon')
            .removeClass('text-brand-green')
            .removeClass('text-brand-red')
            .addClass('text-medium-gray')
            .removeClass('hidden');
        $('.coming-soon-error').addClass('hidden');
        $('.availability-msg-for-small')
            .empty()
            .html($('.product-availability').data('notifymelabel'))
            .removeClass('uppercase')
            .removeClass('text-salmon')
            .removeClass('text-brand-green')
            .removeClass('text-brand-red')
            .addClass('text-medium-gray')
            .removeClass('hidden');
        $('.out-of-stock-error').removeClass('hidden');
        $('.notify-block').removeClass('hidden');
    }
};

function getUnavailablePid (unavailableUrl, item){
    let url = $('.getpid-url').data('url');
    let paramUrl = unavailableUrl;
    let queryString = paramUrl.split('Product-Variation')[1];
    let result;
    $.ajax({
        url: url + queryString,
        method: 'GET',
        dataType: 'json',
        success: data => {
            result = data.sku;
            if (result != null || result != undefined){
                $('.product-detail-keeper').attr('data-variant-pid', result );
            }
            $.spinner().stop();
        },
        error: () => {
            $.spinner().stop();
        }
    });
};

function showComingSoonElements(isComingSoon) {
    $('.titleComingSoon, .subTitleComingSoon, .titleNotComingSoon, .subTitleNotComingSoon').addClass('hidden');
    if (isComingSoon) {
        $('.titleComingSoon').removeClass('hidden');
        $('.subTitleComingSoon').removeClass('hidden');
    } else {
        $('.titleNotComingSoon').removeClass('hidden');
        $('.subTitleNotComingSoon').removeClass('hidden');
    }
}

function hideComingSoonElements(isComingSoon) {
    if (isComingSoon) {
        $('.titleComingSoon').addClass('hidden');
        $('.subTitleComingSoon').addClass('hidden');
    } else {
        $('.titleNotComingSoon').addClass('hidden');
        $('.subTitleNotComingSoon').addClass('hidden');
    }
}

class NotifyHelper {

    constructor() {
        this.originalModalContent = null;
        this.initializeOriginalContent();
    }

    initializeOriginalContent() {
        $(document).ready(() => {
            if ($('.js-notifyMe').length > 0) {
                this.originalModalContent = document.querySelector('.js-notifyMe').innerHTML;
            }
        });
    }

    resetModalToOriginalState() {
        $('.toShow').addClass('hidden');
        $('.messageGreen').addClass('hidden');
        $('.comingSoonGreen').addClass('hidden');
        $('.notifyButton').parent().removeClass('hidden');
        $('.continueShopping').addClass('hidden');
        $('.emailError').addClass('hidden');
        $('.emailNotify').removeClass('error').val('');
        $('.duplicateError').addClass('hidden');
        $('.subtitleHide, .notifyBody').removeClass('hidden');
    }

    notifyMeModal = () => {
        $('body').on('click', '.notifyMe', (e) => {
            e.preventDefault();
            $('.pdp-error').addClass('hidden');
            $('.swatch-boolean').find('input:checked').prop('checked',false);
            $('.clicked-size').removeClass('clicked-size');
            ($(e.currentTarget)).siblings('input').addClass('clicked-size');
            $('.sizeSelected').addClass('hidden');
            $('#choose-size-message').hide();
            $.spinner().start();
            let paramUrl = $(e.currentTarget).siblings().data('url') || $(e.currentTarget).data('variant');
            $('.notify-me-button-wrapper').removeClass('hidden');
            if ($(e.currentTarget).hasClass('notifyPopup')){
                let modalId = $(e.currentTarget).attr('data-attr-id');
                $('#' + modalId).addClass('clicked-size');
                $('.prod-select-size-modal .modal__closeIcon').click();
                paramUrl = $(e.currentTarget).data('url');
            }
            getUnavailablePid(paramUrl, e.currentTarget);
            let isComingSoon= $(e.currentTarget).siblings().data('iscomingsoon');
            updateAvailabilityMessage(isComingSoon);
            $('.continueShopping').addClass('hidden');
            $('.emailError').addClass('hidden');
            $('.emailNotify').removeClass('error');
            $('.duplicateError').addClass('hidden');
            $('.titleNotComingSoon').addClass('hidden');

            if (!Foundation.MediaQuery.atLeast('medium')) {
                $('.add-to-cart-mobile').prop('disabled', true);
                $('.attribute-container.quantity.show-for-small-only').addClass('hidden');
                $('.tezenis--fond-yoursize-link.hide-for-large').addClass('hidden');
            }
            this.resetModalToOriginalState();
            const htmlContent = $($(this).data('target')).html();
            const modal = newModalFromString(htmlContent, false, ['wrapperModalNotifyMe']);

            let size = $(e.currentTarget)[0].innerText;
            let color = $('.family-color:first').text().trim() + ' ' + $('.attribute-label:first').text().trim();
            modal.setContent(this.originalModalContent);
            $('.sizeNotify').html(size);
            $('.colorNotify').html(color);
            $('.notifyMe-selectedSize').html(size);

            modal.open();
            showComingSoonElements(isComingSoon);
            $(modal.modalBox).addClass('rightModalAttribute');
            $.spinner().stop();

            $(modal.modalBox).on('click', '.modal__closeIcon, .ico-close, .tingle-modal__closeIcon__back', (e) => {
                modal.close();
                modal.destroy();
                hideComingSoonElements(isComingSoon);
                $('.notify-me-button-wrapper').addClass('hidden');
            });

            $('.notify-me-button-wrapper').off('click').on('click', () => {
                showComingSoonElements(isComingSoon);
                const htmlContent = $($(this).data('target')).html();
                const modal = newModalFromString(htmlContent, false, ['wrapperModalNotifyMe']);
                modal.setContent(this.originalModalContent);
                $('.sizeNotify').html(size);
                $('.colorNotify').html(color);
                $('.notifyMe-selectedSize').html(size);
                showComingSoonElements(isComingSoon);
                modal.open();
       
                $.spinner().stop();
                $(modal.modalBox).on('click', '.modal__closeIcon, .ico-close, .tingle-modal__closeIcon__back', (e) => {
                    modal.close();
                    modal.destroy();
                    hideComingSoonElements(isComingSoon);
                    $('.notify-me-button-wrapper').addClass('hidden');
                });

                $(modal.modalBox).on('click', '.continue-shopping-link', (e) => {
                    modal.close();
                    modal.destroy();
                });
            });

            $('.attribute-container.quantity.hide-for-small-only').addClass('hidden');
            $('.add-to-cart.button.large-10').addClass('hidden');

            $('.submitNotify').off('click').on('click', (e) => {
                $('.notify-me-button-wrapper').removeClass('hidden');
                let email = $('.emailNotify').val();
                let isValid = validateEmail(email);
                let type = !isComingSoon ? 'back-in-stock' : 'coming-soon';
                let queryString = paramUrl.split('Product-Variation')[1];
                if (isValid){
                    let dataForm = {
                        sku: $('#skuNotify').val(),
                        owner: email,
                        type: type
                    };
                    $('body').trigger('soldout:notify');

                    let url = $('.notify-url').val();
                    $.spinner().start();
                    $.ajax({
                        url: url + queryString,
                        method: 'POST',
                        dataType: 'json',
                        data: dataForm,
                        success: data => {
                            $.spinner().stop();
                            if (data.success){
                                $('.toHide').addClass('hidden');
                                if (isComingSoon){
                                    $('.messageGreen').addClass('hidden');
                                    $('.comingSoonGreen').removeClass('hidden');
                                }
                                $('.comingSoonGreen').text(data.messageComingSoon);
                                $('.messageGreen').text(data.message);
                                $('.toShow').removeClass('hidden');
                                $('.notifyButton').parent().addClass('hidden');
                                $('.continueShopping').removeClass('hidden');
                                $('.emailError').addClass('hidden');
                                $('.emailNotify').removeClass('error');
                                $('.duplicateError').addClass('hidden');
                                $('.subtitleHide, .notifyBody').addClass('hidden');
                            } else {
                                if (data.duplicate){
                                    $('.duplicateError').removeClass('hidden');
                                }
                            }
                        },
                        error: () => {
                            $.spinner().stop();
                        }
                    });
                } else {
                    $('.emailError').removeClass('hidden');
                    $('.emailNotify').addClass('error');
                }
            });
        });

        $('body').on('keydown input change paste', '.wrapperModalNotifyMe .emailNotify', function(e) {
            let self = $(this);
            self.removeClass('error');
            $('.emailError').addClass('hidden');
            if(self.val() !== '') {
                self.closest('.input-group').find('.submitNotify').removeClass('disabled');
            } else {
                self.closest('.input-group').find('.submitNotify').addClass('disabled');
            }
        });
    };

    // NEW MODAL DEVELOPED WITH DEM-7941 (Order It Again)
    initModal (modal) {
        $(modal.modalBox).on('click', '.js-notifyMe-modal__footerButton', () => {
            $(modal.modalBox).find('.js-notifyMe-modal__form').trigger('submit');
        });

        $(modal.modalBox).on('submit', '.js-notifyMe-modal__form', (e) => {
            e.preventDefault();

            const url = $(e.currentTarget).attr('action');
            if (!url) {
                return;
            }

            const form = $(e.currentTarget).serialize();
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: form
            }).then((data) => {
                $.spinner().stop();
                if (data.duplicate) {
                    $(modal.modalBox).find('.js-notifyMe-modal__duplicateError').removeClass('hide');
                } else {
                    $('.js-notifyMe-modal__body').hide();
                    $('.js-notifyMe-modal__result').html(data);
                }
            }).catch(() => {
                $.spinner().stop();
            });
        });
    }
}
const notifyHelper = new NotifyHelper();

export default notifyHelper;
